const apiBaseUrl = 'https://student-api-demo.nessy.com/';
const notificationsAPIPath = 'https://notifications-api-demo.nessy.com/';
const accountAPIPath = 'https://account-api-demo.nessy.com/';
const gamesAPIPath = 'https://students-demo.nessy.com/';
const configAPIPath = 'https://config-demo.nessy.com/';

export const environment = {
  settings: {
    name: 'demo',
    production: false,
    clientId: 'nessy.games.client',
    authAuthority: 'https://nessy-id-demo.nessy.com',
    cookieDomain: 'nessy.com',
  },
  gamesBaseUrl: {
    application: `${gamesAPIPath}learning/{license}?rToken={sessionToken}`,
  },
  api: {
    root: apiBaseUrl,
    studentRoot: apiBaseUrl,
    gameData: `${apiBaseUrl}GamesContainerData`,
    config: `${configAPIPath}versionConfiguration?App=`,
    notificationsRoot: notificationsAPIPath,
    notifications: {
      getNotifications: `${notificationsAPIPath}notifications`,
      markRead: `${notificationsAPIPath}markRead`,
    },
    avatar: {
      getAvatarItems: `${accountAPIPath}avatarItems`,
      upsertAvatarItems: `${accountAPIPath}upsertAvatarItems`,
    },
  },
};
